export const countryNameToCode = {
  'afghanistan': '+93',
  'albania': '+355',
  'algeria': '+213',
  'andorra': '+376',
  'angola': '+244',
  'argentina': '+54',
  'armenia': '+374',
  'australia': '+61',
  'austria': '+43',
  'azerbaijan': '+994',
  'bahamas': '+1242',
  'bahrain': '+973',
  'bangladesh': '+880',
  'belarus': '+375',
  'belgium': '+32',
  'bhutan': '+975',
  'bolivia': '+591',
  'brazil': '+55',
  'bulgaria': '+359',
  'cambodia': '+855',
  'cameroon': '+237',
  'canada': '+1',
  'chile': '+56',
  'china': '+86',
  'colombia': '+57',
  'costa rica': '+506',
  'croatia': '+385',
  'cuba': '+53',
  'cyprus': '+357',
  'czech republic': '+420',
  'denmark': '+45',
  'egypt': '+20',
  'estonia': '+372',
  'ethiopia': '+251',
  'fiji': '+679',
  'finland': '+358',
  'france': '+33',
  'georgia': '+995',
  'germany': '+49',
  'ghana': '+233',
  'greece': '+30',
  'hungary': '+36',
  'iceland': '+354',
  'india': '+91',
  'indonesia': '+62',
  'iran': '+98',
  'iraq': '+964',
  'ireland': '+353',
  'israel': '+972',
  'italy': '+39',
  'japan': '+81',
  'kenya': '+254',
  'kuwait': '+965',
  'malaysia': '+60',
  'mexico': '+52',
  'nepal': '+977',
  'netherlands': '+31',
  'new zealand': '+64',
  'nigeria': '+234',
  'norway': '+47',
  'oman': '+968',
  'pakistan': '+92',
  'philippines': '+63',
  'poland': '+48',
  'portugal': '+351',
  'qatar': '+974',
  'romania': '+40',
  'russia': '+7',
  'saudi arabia': '+966',
  'singapore': '+65',
  'south africa': '+27',
  'south korea': '+82',
  'spain': '+34',
  'sri lanka': '+94',
  'sweden': '+46',
  'switzerland': '+41',
  'thailand': '+66',
  'turkey': '+90',
  'uganda': '+256',
  'ukraine': '+380',
  'united arab emirates': '+971',
  'united kingdom': '+44',
  'united states': '+1',
  'vietnam': '+84',
  'zimbabwe': '+263',
};

export const getCountryCodeByRegion = (region) => {
  if (!region) return '';
  const lowerCaseRegion = region.toLowerCase().trim();

  if (countryNameToCode[lowerCaseRegion]) {
    return countryNameToCode[lowerCaseRegion];
  }

  for (const country in countryNameToCode) {
    if (lowerCaseRegion.includes(country)) {
      return countryNameToCode[country];
    }
  }
  return '';
};